import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

// Service
export const getCampaign = async (code) => {
  if (!code) return null; // avoid unnecessary call
  try {
    const res = await axios.get(
      `${API_BASE_URL}/Campaign/SingleCampaignByCode?code=${code}`
    );
    return res.data;
  } catch (err) {
    console.error("Error fetching campaign:", err.message);
    throw err;
  }
};

export const resolveCampaign = async (lat, lon) => {
  return axios.post(`${API_BASE_URL}/Campaign/resolve-campaign`, {
    latitude: lat,
    longitude: lon,
  });
};

export const getCampaigns = async () => {
  const res = await axios.get(`${API_BASE_URL}/Campaign/available-campaigns`);
  return res.data; 
};

